import { DietId } from 'types';

export const DIETS = 'api/v1/diets';
export const DIET = (dietId: DietId) => `api/v1/diets/${dietId}`;

export const DIETS_CHILD = 'api/v1/diets/childDiet';
